var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.getBusinessCardWidth),expression:"getBusinessCardWidth"}],ref:"businesscardContainer",class:[
    'rootDiv reverseImage',
    'd-flex',
    _vm.$route.name == 'ManageCard' && _vm.reverseImageURL == ''
      ? 'justify-center align-center'
      : 'justify-end align-end',
  ],style:(`
 
  height: ${_vm.businessCardHeight}px; 
  border-radius: ${_vm.businessCardBorderRadius}px; 
  background-image:url('${_vm.reverseImageURL}');
  `)},[(_vm.$route.name == 'ManageCard' && _vm.reverseImageURL == '')?[_vm._m(0)]:_vm._e(),(_vm.reverseCardLink != '')?_c('div',{staticClass:"lighten-4 d-flex justify-center text-center cursor-pointer",style:(`background-color: #C5CDDA;height: ${_vm.openLinkContainerSize}px; width:${_vm.openLinkContainerSize}px; border-radius: 4px; margin-right:4px;margin-bottom:4px;`),on:{"click":function($event){return _vm.openLink()}}},[_c('v-icon',{attrs:{"size":_vm.openLinkIconSize,"color":"white"}},[_vm._v("mdi-link-variant")])],1):_vm._e()],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey--text text-center"},[_vm._v(" Add your design to the "),_c('br'),_vm._v(" back of your card ")])
}]

export { render, staticRenderFns }